import Big from 'big.js';

export const isVersionSupported = (browserName: string, browserVersion: string): boolean => {
  const versionWithSingleDecimalArr = browserVersion ? browserVersion.split('.') : [];
  const versionWithSingleDecimal =
    versionWithSingleDecimalArr.length > 1
      ? `${versionWithSingleDecimalArr[0]}.${versionWithSingleDecimalArr[1]}`
      : `${versionWithSingleDecimalArr[0]}`;

  const version = new Big(versionWithSingleDecimal);

  switch (browserName) {
    case 'edge': {
      return version.gte(16);
    }
    case 'edge-chromium': {
      return version.gte(79);
    }
    case 'samsung': {
      return version.gte(7);
    }
    case 'crios':
    case 'chrome': {
      return version.gte(57);
    }
    case 'firefox': {
      return version.gte(52);
    }
    case 'android': {
      return version.gte(67);
    }
    case 'ios': {
      return version.gte(10.3);
    }
    case 'safari': {
      return version.gte(10.1);
    }
    case 'opera': {
      return version.gte(44);
    }
  }
  return false;
};
